.page {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--space-2);
}

.linkButton {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  height: 32px;
  padding: 0 var(--space-3);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  background: var(--bg-surface);
  color: var(--text-primary);
  font-size: var(--text-sm);
  font-weight: var(--weight-medium);
  text-decoration: none;
  transition: background var(--duration-fast) var(--ease-out);
}

.linkButton:hover {
  background: var(--bg-hover);
}

.linkButton:focus-visible {
  outline: 2px solid var(--ring-focus);
  outline-offset: 2px;
}

.notice {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  margin-bottom: var(--space-3);
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--accent-border);
  border-radius: var(--radius-md);
  background: var(--accent-subtle);
  color: var(--text-secondary);
  font-size: var(--text-sm);
  line-height: var(--leading-normal);
}

.notice svg {
  flex: none;
  color: var(--accent);
}

.frameWrap {
  position: relative;
  /* Fill the remaining viewport under the top bar and page header. */
  height: calc(100dvh - var(--topbar-height) - 15rem);
  min-height: 560px;
  border: 1px solid var(--border-default);
  border-radius: var(--radius-lg);
  overflow: hidden;
  background: #04060a; /* MindOS's own background, avoids a flash while it loads */
  box-shadow: var(--shadow-md);
}

.frame {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}

@media (max-width: 640px) {
  .frameWrap {
    height: calc(100dvh - var(--topbar-height) - 12rem);
    min-height: 480px;
  }
}
